<template>
    <div class="subscription">
        <div class="container">
            <h2 class="subscription__title">
                Подписка на Древо и Страницы Памяти
            </h2>
            <swiper class="subscription__tariffs-container" :options="swiperOptions">
                <swiper-slide class="subscription__block" :class="{ 'subscription__block--active': tariff.active }"
                    v-for="tariff in tariffs" :key="tariff.id">
                    <div class="subscription__active-msg" v-if="tariff.active">
                        {{ $lang("tariffs.optimal") }}
                    </div>
                    <div class="subscription__info">
                        <h3 class="title title--uppercase title--xs subscription__tariffs-title">
                            {{ tariff.name }}
                        </h3>
                        <ul class="subscription__tariffs-advantages">
                            <li v-for="advantage in tariff.advantages" :key="advantage.id"
                                class="subscription__tariffs-advantage">
                                <svg class="tariffs__a-options-icon" width="25" height="25">
                                    <use :xlink:href="'/assets/front/img/sprite.svg#icon-' +
                                        advantage.icon
                                        "></use>
                                </svg>
                                <div class="subscription__tariffs-content">
                                    <div class="subscription__tariffs-text" v-html="advantage.name"></div>
                                    <div v-if="advantage.description" class="subscription__tariffs-description">
                                        {{ advantage.description }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="subscription__action">
                        <div class="subscription__tariffs-discount">
                            {{ tariff.discount }}
                        </div>
                        <div v-if="tariff.id === 3" class="subscription__tariffs-price">
                            {{ tariff.price }} ₽ / год.
                        </div>
                        <div v-else class="subscription__tariffs-price">
                            {{ tariff.price }} ₽ / мес.
                        </div>
                        <a class="btn btn--main-bg btn--middle subscription__btn"
                            @click.stop="selectSubscription(tariff,tariff.id)">
                            Выбрать
                        </a>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <el-dialog class="popup popup--success" :width="windowWidth > 992 ? '770px' : '75%'" top="50vh"
            :append-to-body="true" :show-close="false" :visible.sync="show">
            <div class="popup__success">
                <span> Подписка уже оформлена </span>
            </div>
        </el-dialog>

        <el-dialog :width="windowWidth > 992 ? '770px' : '100%'" :top="windowWidth > 992 ? '15vh' : '0px'"
            :visible.sync="isFormVisible" :append-to-body="true">
            <div class="popup__header">
                <span class="title title--sm popup__title">ОПЛАТА ПОДПИСКИ</span>
                <button class="btn popup__close popup__close--fixed" @click.prevent="isFormVisible = false">
                    <i class="el-icon-close"></i>
                </button>
            </div>

            <div class="popup__content subscribe__popup">

                <div class="subscription-form__price subscription-form__info">
                    <span class="order__price-name">{{ selectedTariff.name }}</span>
                    <div class="order__price-count">{{ selectedTariff.price }} ₽</div>
                </div>

                <div class="order__total">
                    <div>{{ $lang('Delivery.order.sum') }} </div>
                    <div class="order__total-price">
                        {{ selectedTariff.price }} ₽
                    </div>
                </div>

                <div class="order__promo-code-title">укажите ваш e-mail, мы вышлем на него чек и информацию о подписке</div>

                <form class="ainoxform" @submit.prevent="submitForm">
                    <el-input type="email" v-model="form.email" class="input input--big" required
                        :placeholder="$lang('email.input.placeholder')" />
                    <button type="submit"
                        class="btn btn--main-bg btn--middle subscription__btn">{{ $lang('Delivery.order.pay') }}</button>
                </form>

                <div class="subscription__policy">
                    Нажимая кнопку "Оплатить", Вы подтверждаете, что
                    ознакомлены с положениями
                    <a href="/assets/front/pdf/memorycode_oferta.pdf" class="subscription-link" target="_blank">
                        Публичного договора - оферты ООО "Код Памяти"
                    </a>
                    и принимаете их
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ApiService from '../api/api';

export default {
    name: "SubscriptionBanner",
    data() {
        return {
            subscriptionId: window.laravel.subscription?.id || null,
            show: false,
            isFormVisible: false,
            selectedTariff: {},
            form: {
                email: laravel.user ? laravel.user.email : '',
                tariff: {},
            },
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 15,
                breakpoints: {
                    350: {
                        slidesPerView: 1.05,
                        spaceBetween: 15
                    },
                    550: {
                        slidesPerView: 1.5,
                        spaceBetween: 15
                    },
                    650: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    900: {
                        slidesPerView: 2.5,
                        spaceBetween: 15
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    }
                }
            },
            tariffs: [
                {
                    id: 1,
                    name: "Мое Древо",
                    product_name: window.laravel.subscriptionTypes[0].title,
                    discount: "",
                    price: parseInt(
                        window.laravel.prices.subscriptionMyTree.price
                    ),
                    payment_type:
                        window.laravel.paymentTypes.subscriptionMyTree,
                    subscription_type_id:
                        window.laravel.subscriptionTypes[0].id,
                    advantages: [
                        {
                            id: 1,
                            name: "Доступ ко всему функционалу древа памяти",
                            icon: "subscription_access"
                        },
                        {
                            id: 2,
                            name:
                                "Бесплатно: 10 расширенных страниц без физических куар-кодов",
                            description:
                                "Вы сможете расширить до 10 кратких страниц и получить расширенные страницы памяти без физических куар-кодов",
                            icon: "subscription_page"
                        },
                        {
                            id: 3,
                            name:
                                "Приоритетная поддержка от нашей службы заботы",
                            icon: "subscription_help",
                            description:
                                "Наши специалисты поддержки внимательно выслушают ваш вопрос и ответят максимально точно и без очереди"
                        }
                    ],
                    active: false
                },
                {
                    id: 2,
                    name: "Мое Древо +",
                    product_name: window.laravel.subscriptionTypes[1].title,
                    discount: "499 ₽ / мес.",
                    price: parseInt(
                        window.laravel.prices.subscriptionMyTreePlus.price
                    ),
                    payment_type:
                        window.laravel.paymentTypes.subscriptionMyTreePlus,
                    subscription_type_id:
                        window.laravel.subscriptionTypes[1].id,
                    advantages: [
                        {
                            id: 1,
                            name: "Доступ ко всему функционалу древа памяти",
                            icon: "subscription_access"
                        },
                        {
                            id: 2,
                            name:
                                'Бесплатно: ' + '<span class="subscription__text-blue">' + 'неограниченное' + '</span>' + ' число расширенных страниц',
                            description:
                                "Вы сможете расширить любое число кратких страниц и получить расширенные страницы памяти без физических куар-кодов",
                            icon: "subscription_page"
                        },
                        {
                            id: 3,
                            name:
                                "Приоритетная поддержка от нашей службы заботы",
                            icon: "subscription_help",
                            description:
                                "Наши специалисты поддержки внимательно выслушают ваш вопрос и ответят максимально точно и без очереди"
                        }
                    ],
                    active: true
                },
                {
                    id: 3,
                    name: "мое древо + (на год)",
                    product_name: window.laravel.subscriptionTypes[2].title,
                    discount: "5988 ₽ / год",
                    price: parseInt(
                        window.laravel.prices.subscriptionMyTreePlusForYear
                            .price
                    ),
                    payment_type:
                        window.laravel.paymentTypes
                            .subscriptionMyTreePlusForYear,
                    subscription_type_id:
                        window.laravel.subscriptionTypes[2].id,
                    advantages: [
                        {
                            id: 1,
                            name: "Доступ ко всему функционалу древа памяти",
                            icon: "subscription_access"
                        },
                        {
                            id: 2,
                            name:
                                'Бесплатно: ' + '<span class="subscription__text-blue">' + 'неограниченное' + '</span>' + ' число расширенных страниц',
                            description:
                                "Вы сможете расширить любое число кратких страниц и получить расширенные страницы памяти без физических куар-кодов",
                            icon: "subscription_page"
                        },
                        {
                            id: 3,
                            name:
                                "Приоритетная поддержка от нашей службы заботы",
                            icon: "subscription_help",
                        },
                        {
                            id: 4,
                            name:
                                'При оплате за год, мы посадим от вашего имени настоящее дерево, в сотрудничестве с проектом ' + '<span class="subscription__text-blue">' + `"Посади лес"` + '</span>',
                            description:
                                "Вы получите сертификат о своем вкладе в лесовосстановление. А после посадки дерева,на электронную почту придет  отчет с описанием акции, фотографиями, видеороликом и GPS-координатами восстановленного участка.",
                            icon: "subscription_tree"
                        }
                    ],
                    active: false
                }
            ]
        };
    },
    mounted() {
        if(this.$route.query.hasOwnProperty('selectedTarif')) {
            this.selectSubscription(this.tariffs[this.$route.query.selectedTarif]);
        }
    },
    methods: {
        redirectTo(path) {
            return (window.location.href = window.laravel.prefix + path);
        },
        showModalSubscription() {
            this.show = true
            setTimeout(() => {
                this.show = false
            }, 2000)
        },
        selectSubscription(tariff,key) {
            if (this.subscriptionId) {
                this.showModalSubscription()
            }
            else {
                if (!laravel.user) {
                    let selectedId = this.tariffs.map((el)=>el.id === key).indexOf(true);
                    this.$router.push({name: 'login', query: {redirect: '/page/subscriptions?selectedTarif=' + selectedId}});
                    return;
                }

                this.isFormVisible = true;
                this.selectedTariff = tariff;
                this.form.type = tariff.subscription_type_id;
            }
        },
        redirectSubscription(tariff) {
            if (this.subscriptionId) {
                this.showModalSubscription()
            }
            else {
                let params = {
                    product_name: tariff.product_name,
                    payment_type: tariff.payment_type,
                    email: this.form.email,
                    price: tariff.price,
                    subscription_type_id: tariff.subscription_type_id
                };

                params = new URLSearchParams(params);

                this.redirectTo(`/payment-subscription?${params.toString()}`);
            }
        },
        submitForm() {
            ApiService.post('/subscribe', this.form).then((Response) => {
                console.log(Response);
                let data = Response.data;
                if (data.success && data.oplata)
                    window.location = data.url;
            }).catch((error) => {
                console.error(error);
            });
        }
    }
};
</script>

<style lang="scss">
.subscribe__popup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
}

.ainoxform {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
</style>
